__turbopack_context__.v({
  "alt-cta": "_5d2yrG_alt-cta",
  "button": "_5d2yrG_button",
  "closer-statement-section": "_5d2yrG_closer-statement-section",
  "cta-container": "_5d2yrG_cta-container",
  "grid-item-image": "_5d2yrG_grid-item-image",
  "grid-item-text": "_5d2yrG_grid-item-text",
  "image-container": "_5d2yrG_image-container",
  "img-container": "_5d2yrG_img-container",
  "outer-grid-container": "_5d2yrG_outer-grid-container",
  "text-container": "_5d2yrG_text-container",
  "title": "_5d2yrG_title",
});
